export default "__VITE_ASSET__BHmbDOWo__"